var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "settinghome-container" }, [
    _c(
      "div",
      { staticClass: "setting-content" },
      _vm._l(
        _vm.menu.filter((v) => !["site008", "site009"].includes(v.menuCode)),
        function (list, index) {
          return _c("div", { key: index, staticClass: "page-card-item" }, [
            _c(
              "div",
              {
                staticClass: "item",
                on: {
                  click: function ($event) {
                    return _vm.goTo(list)
                  },
                },
              },
              [
                _c(
                  "label",
                  {
                    class: [
                      "bottom",
                      _vm.$i18n.locale === "en" ? "en-fontSize" : "",
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "card-icon" },
                      [
                        _c("svg-icon", {
                          attrs: {
                            "icon-name": `Setting_${list.href}`,
                            size: "32",
                            iconColor: "#1e49e2",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.$t(list.menuCode)))]),
                  ]
                ),
              ]
            ),
          ])
        }
      ),
      0
    ),
    _vm.menu.filter((v) => ["site008", "site009"].includes(v.menuCode)).length
      ? _c("div", { staticClass: "setting-title" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("component_team_mgt")) + "\n    "
          ),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "setting-content" },
      _vm._l(
        _vm.menu.filter((v) => ["site008", "site009"].includes(v.menuCode)),
        function (v, k) {
          return _c("div", { key: k, staticClass: "page-card-item" }, [
            _c(
              "div",
              {
                staticClass: "item",
                on: {
                  click: function ($event) {
                    return _vm.goTo(v)
                  },
                },
              },
              [
                _c(
                  "label",
                  {
                    class: [
                      "bottom",
                      _vm.$i18n.locale === "en" ? "en-fontSize" : "",
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "card-icon" },
                      [
                        _c("svg-icon", {
                          attrs: {
                            "icon-name": `Setting_${v.href}`,
                            size: "32",
                            iconColor: "#1e49e2",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t(`${v.menuCode}_settingHome`)),
                      },
                    }),
                  ]
                ),
              ]
            ),
          ])
        }
      ),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }